/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import styled from '@emotion/styled'
import { alpha, TableCell, tableCellClasses, TableRow, type TableCellProps, type TableRowProps } from '@mui/material'

interface StyledCardTableCellProps extends TableCellProps {
  isTableHeader?: boolean
  rowSelected?: boolean
}

export const StyledCardTableCell = styled(TableCell, {
  shouldForwardProp: prop => prop !== 'isTableHeader' && prop !== 'rowSelected',
})<StyledCardTableCellProps>(({ isTableHeader = false, rowSelected = false }) => ({
  [`&.${tableCellClasses.root}`]: {
    borderBottom: `1px solid ${rowSelected ? '#D0D5DD' : '#EAECF0'}`,
    padding: isTableHeader ? '12px 24px' : '16px 24px',
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#F9FAFB',
    color: '#475467',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: isTableHeader ? 12 : 14,
  },
}))

export const StyledCardTableRow = styled(TableRow)<TableRowProps>(({ theme, selected }) => ({
  '&.Mui-selected': {
    backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.selectedOpacity),
  },
  '&.Mui-selected:hover': {
    backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
  },
}))
